export const FETCH_BANKS_INIT_ACTION = "FETCH_BANKS_INIT_ACTION";
export const FETCH_BANKS_SUCCESS_ACTION =
  FETCH_BANKS_INIT_ACTION + "_SUCCESS";
export const FETCH_BANKS_FAIL_ACTION = FETCH_BANKS_INIT_ACTION + "_ERROR";

export const ADD_BANK_INIT_ACTION = "ADD_BANK_INIT_ACTION";
export const ADD_BANK_SUCCESS_ACTION = ADD_BANK_INIT_ACTION + "_SUCCESS";
export const ADD_BANK_FAIL_ACTION = ADD_BANK_INIT_ACTION + "_ERROR";

export const EDIT_BANK_INIT_ACTION = "EDIT_BANK_INIT_ACTION";
export const EDIT_BANK_SUCCESS_ACTION = EDIT_BANK_INIT_ACTION + "_SUCCESS";
export const EDIT_BANK_FAIL_ACTION = EDIT_BANK_INIT_ACTION + "_ERROR";

export const FETCH_BANK_SEARCH_INIT_ACTION = "FETCH_BANK_SEARCH_INIT_ACTION";
export const FETCH_BANK_SEARCH_SUCCESS_ACTION =
  FETCH_BANK_SEARCH_INIT_ACTION + "_SUCCESS";
export const FETCH_BANK_SEARCH_FAIL_ACTION =
  FETCH_BANK_SEARCH_INIT_ACTION + "_ERROR";

export function fetchBanks() {
  return {
    type: FETCH_BANKS_INIT_ACTION
  };
}

export function AddBank(value) {
  // console.log(value);
  return {
    type: ADD_BANK_INIT_ACTION,
    value: value
  };
}

export function EditBank(value) {
  return {
    type: EDIT_BANK_INIT_ACTION,
    value: value
  };
}

export function bankSearch(value) {
  return {
    type: FETCH_BANK_SEARCH_INIT_ACTION,
    value: value
  };
}

export function bankSlectedPage(value) {
  return {
    type: FETCH_BANKS_INIT_ACTION,
    value: value
  };
}
